/** Holiday rows scroll inside `.editor`; prefer that over Divii's tab panel. */
export function getScrollContainer(startEl) {
  if (!startEl) return null
  const editor = startEl.closest('.holiday-builder .editor')
  if (editor) return editor

  let el = startEl.parentElement
  while (el && el !== document.body) {
    const { overflowY } = window.getComputedStyle(el)
    if (overflowY === 'auto' || overflowY === 'scroll' || overflowY === 'overlay') {
      return el
    }
    el = el.parentElement
  }
  return null
}

/** @deprecated Use getScrollContainer */
export function findScrollContainer(startEl) {
  return getScrollContainer(startEl)
}

export function readScrollTop(scroller) {
  if (!scroller || scroller === document.documentElement) return window.scrollY
  return scroller.scrollTop
}

export function writeScrollTop(scroller, top) {
  if (!scroller || scroller === document.documentElement) {
    window.scrollTo(0, top)
    return
  }
  scroller.scrollTop = top
}

/**
 * When a block above `targetEl` collapses, content shifts up. Nudge scroll so
 * `targetEl` stays at the same viewport position (when scroll room allows).
 */
export function compensateScrollForCollapseAbove(scroller, scrollTop, collapseDelta) {
  if (!collapseDelta || collapseDelta <= 0) return
  const apply = () => writeScrollTop(scroller, Math.max(0, scrollTop - collapseDelta))
  apply()
  requestAnimationFrame(() => requestAnimationFrame(apply))
}

/** Height of `bodyEl` when `prevEl` sits directly above `targetEl` in the document. */
export function measureCollapseAbove(prevEl, targetEl, bodyEl) {
  if (!prevEl || !targetEl || !bodyEl) return 0
  if (!(prevEl.compareDocumentPosition(targetEl) & Node.DOCUMENT_POSITION_FOLLOWING)) return 0
  return bodyEl.getBoundingClientRect().height
}
